import { useMemo } from 'react'
import { Column } from 'react-table'
import Table from '../../../global/components/table/Table'
import DeleteButton from '../../../global/components/buttons/delete-button/DeleteButton'

export interface EvaluationQuestionItem {
  objectId: string
  query: string
  expectedAllowed: boolean
  expectedAnswer: string | null
}

interface EvaluationTableProps {
  questions: EvaluationQuestionItem[]
  isLoading: boolean
  onDelete: (objectId: string) => void
}

function EvaluationTable({ questions, isLoading, onDelete }: EvaluationTableProps) {
  const columns: Column<any>[] = useMemo(
    () => [
      {
        Header: 'Question',
        accessor: 'query',
      },
      {
        Header: 'Expected',
        Cell: ({ row }: any) =>
          row.original.expectedAllowed ? 'Allow' : 'Block',
      },
      {
        Header: 'Actions',
        Cell: ({ row }: any) => (
          <DeleteButton
            buttonName='Delete'
            onClick={(e) => {
              e.stopPropagation()
              onDelete(row.original.objectId)
            }}
          />
        ),
      },
    ],
    [onDelete],
  )

  return (
    <Table
      columns={columns}
      data={questions}
      isLoading={isLoading}
      isDisplayMode={true}
      noDataMessage='No evaluation questions added yet.'
    />
  )
}

export default EvaluationTable
